import React from 'react'
import { Redirect } from 'react-router-dom'

const HomeRedirect = () => <Redirect to='/' />

export default HomeRedirect
